import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";

interface Text {
  text: string;
  headingColor?: "primary" | "secondary";
}

export const Text = ({ text, headingColor = "primary" }: Text) => {
  return (
    <div
      className="prose max-w-full"
      style={
        { "--heading-color": `var(--${headingColor})` } as React.CSSProperties
      }
    >
      <CourseMarkdown>{text}</CourseMarkdown>
    </div>
  );
};
